export default function checkIfOpen(element: HTMLElement) {
    if(element.querySelector('.wp-block-taxonomy-filter-filter.open')) {
        element.classList.add('filter-open');
    } else {
        element.classList.remove('filter-open');
    }
}